import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

export interface NoDataOverlayProps {
  width: number;
  height: number;
}

export const NoDataOverlay: React.FC<NoDataOverlayProps> = ({
  width,
  height,
}: NoDataOverlayProps) => {
  const centerX = width / 2;
  const centerY = height / 2;
  const iconSize = 48;
  const fontSize = 14;
  const { t } = useI18nHelper();

  return (
    <g color={"#8F8F8C"}>
      <text
        x={centerX}
        y={centerY}
        textAnchor="middle"
        fill="#444444"
        fontSize={fontSize}
      >
        {/* 첫 번째 줄: 중앙에서 위쪽으로 살짝 올리기 */}
        <tspan x={centerX} dy={-fontSize * 0.1}>
          {t("no_data_markup_chart_line1")}
        </tspan>
        {/* 두 번째 줄: 첫 줄 기준으로 아래에 배치 */}
        <tspan x={centerX} dy={fontSize * 1.4}>
          {t("no_data_markup_chart_line2")}
        </tspan>
      </text>
    </g>
  );
};
